import React, { Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

const Index = React.lazy(() => import("./pages/Index"));
const Privacy = React.lazy(() => import("./pages/Privacy"));
const Terms = React.lazy(() => import("./pages/Terms"));
const NotFoundPage = React.lazy(() => import("./pages/NotFound"));
const ReturnPolicy = React.lazy(() => import("./pages/Return"));
const McpGuide = React.lazy(() => import("./pages/McpGuide"));

function App() {
  return (
    <Suspense
      fallback={
        <div className="flex h-screen w-screen items-center justify-center bg-stone">
          <p className="font-display text-2xl font-semibold text-primary lg:text-4xl">
            Loading Flip…
          </p>
        </div>
      }
    >
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/termsofuse" element={<Terms />} />
          <Route path="/return-policy" element={<ReturnPolicy />} />
          <Route path="/mcp" element={<McpGuide />} />
          <Route path="/meal/*" element={<PassengerAppRedirect />} />
          <Route path="/restaurant/*" element={<RestaurantAppRedirect />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </Suspense>
  );
}

/** Deep links for passenger food / meal shares → customer store listings */
function PassengerAppRedirect() {
  React.useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    let redirectUrl = "https://download.flip.delivery/app";

    if (/android/i.test(userAgent)) {
      redirectUrl =
        "https://play.google.com/store/apps/details?id=com.cuberobotics.gh_delivery";
    } else if (/ipad|iphone|ipod/.test(userAgent) && !window.MSStream) {
      redirectUrl = "https://apps.apple.com/app/id1613176191";
    }

    window.location.href = redirectUrl;
  }, []);

  return <div className="p-8 text-center">Redirecting to the Flip app…</div>;
}

/** Restaurant partner deep links → restaurant download hub (not passenger) */
function RestaurantAppRedirect() {
  React.useEffect(() => {
    window.location.href = "https://download.flip.delivery/restaurant";
  }, []);

  return (
    <div className="p-8 text-center">Redirecting to Flip Restaurant…</div>
  );
}

export default App;
